import React from 'react'
import remoteServer from '../remoteServer'

export const PostHOC = ComposedComponent => class extends React.Component {
  static displayName = 'ComponentPostHOC';

  componentDidMount () {
    // TODO: initial_detail_post затирает весь массив в Store на один выбранный - исправить
    // if (this.props.posts.length === 0)
      remoteServer.get('/articles')
        .then((response) => {
          this.props.addPost(response.data.data)
        })
  }

  render () {
    return <ComposedComponent {...this.props} {...this.state} />;
  }
}